import React from 'react';
import ICellProps, { ITranchRow } from './ICellProps';
import { BodyCell } from '@creditflowresearch/uilib/Table/DataTable';
import { formatDataCell, getTrancheFieldWithPercent } from '@/creditflowresearch/ui/components/deals/helpers';

import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';

const getCell = ({ row: tranche }: ITranchRow) => formatDataCell(getTrancheFieldWithPercent(tranche.coupon, 3));

const CouponCell = ({
  rowIndex,
  tranche,
}: ICellProps) => (
  <BodyCell
    name="CouponCell"
    className={ alignStyles.alignRight }
    rowIndex={ rowIndex }
    rowData={ tranche }
    cellCallback={ getCell }
  />
);

export default CouponCell;
